<template>
  <b-form-group
    label="İade Açıklaması"
    label-for="notes"
  >
    <validation-provider
      #default="{ errors }"
      name="İade Açıklaması"
      rules="required"
    >
      <b-form-textarea
        id="return_notes"
        v-model="promissory.return_notes"
        placeholder="İade Açıklaması"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'Notes',
  components: {
    BFormGroup,
    BFormTextarea,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    promissory() {
      return this.$store.getters['promissories/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
